// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warrior-container {
  background-color: #000000;
  padding: 80px 120px;
  color: white;
  position: relative;
  overflow: hidden;
}

.warrior-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 40px;
  right: 40px;
  bottom: 0;
  background-image: var(--bg-image);
  background-size: cover;
  background-position: center;
  opacity: 0.6;
  z-index: 1;
}

.warrior-content {
  display: flex;
  gap: 60px;
  position: relative;
  z-index: 2;
  max-width: 1400px;
  margin: 0 auto;
}

.warrior-text {
  flex: 1 1;
  padding-top: 40px;
}

.warrior-text h1 {
  font-size: 64px;
  font-weight: bold;
  line-height: 1.1;
  margin: 0 0 30px 0;
  text-transform: uppercase;
}

.warrior-text .description {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 20px;
  max-width: 600px;
}

.warrior-text .companies {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
  max-width: 600px;
}

.know-more-btn {
  background-color: #A41E22;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.know-more-btn:hover {
  background-color: #8a1a1d;
}

.warrior-images {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-image {
  width: 371px;
  height: 583px;
  background-image: url('https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/Corporate_Thumbnail.webp');
  background-size: cover;
  background-position: center;
  position: relative;
  margin-left: auto;
  right: 70px;
}

/* Video styling */
video.main-image {
  background-image: none;
  object-fit: cover;
  width: 371px;
  height: 583px;
  position: relative;
  margin-left: auto;
  right: 70px;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background-color: rgba(164, 30, 34, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.play-button span {
  color: white;
  font-size: 24px;
  margin-left: 4px;
}
@media (max-width: 768px) {
  .play-pause-button{
    padding-top: 100px;
  }
}

@media (max-width: 768px) {

  .warrior-container {
    padding: 40px 20px;
  }

  .warrior-container::before {
    left: 0;
    right: 0;
  }

  .warrior-content {
    flex-direction: column;
    gap: 30px;
  }

  .warrior-text h1 {
    font-size: 36px;
    text-align: center;
  }

  .warrior-text .description,
  .warrior-text .companies {
    text-align: center;
    font-size: 16px;
  }

  .know-more-btn {
    display: block;
    margin: 0 auto;
  }

  .warrior-images {
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .main-image {
    position: relative;
    right: 0;
    margin: 0 auto;
    width: 100%;
    max-width: 371px;
    height: auto;
    aspect-ratio: 371/583;
  }

  .play-pause-button {
    position: absolute;
    top: 72% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
  }

  video.main-image {
    position: relative;
    right: 0;
    margin: 0 auto;
    width: 100%;
    max-width: 371px;
    height: auto;
    aspect-ratio: 371/583;
  }

  .mute-button {
    width: 35px;
    height: 35px;
    bottom: 15px;
    right: 30px !important;
  }
}

/* Just add these new rules at the end of the file */
video::-webkit-media-controls {
  display: none !important;
}

video::-webkit-media-controls-enclosure {
  display: none !important;
}

.play-pause-button {
  position: absolute;
  top: 50%;
  left: 78%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  color: white;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.mute-button {
  position: absolute;
  bottom: 20px;
  right: 80px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: white;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.play-pause-button:hover,
.mute-button:hover {
  background: rgba(0, 0, 0, 0.9);
}

/* @media (min-width: 768px) and (max-width: 1024px) {
  .warrior-container {
    padding: 60px 40px !important;
  }

  .warrior-content {
    gap: 30px !important;
  }

  .warrior-text h1 {
    font-size: 48px !important;
  }

  .warrior-text .description,
  .warrior-text .companies {
    font-size: 16px !important;
    max-width: 450px !important;
  }
  .main-image {
    width: 300px !important;
    height: 471px !important;
    right: 30px !important;
  }

  video.main-image {
    width: 300px !important;
    height: 471px !important;
  }
} */

`, "",{"version":3,"sources":["webpack://./src/components/newSeason/warrior.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,SAAS;EACT,iCAAiC;EACjC,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6GAA6G;EAC7G,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA,oDAAoD;AACpD;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG","sourcesContent":[".warrior-container {\n  background-color: #000000;\n  padding: 80px 120px;\n  color: white;\n  position: relative;\n  overflow: hidden;\n}\n\n.warrior-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 40px;\n  right: 40px;\n  bottom: 0;\n  background-image: var(--bg-image);\n  background-size: cover;\n  background-position: center;\n  opacity: 0.6;\n  z-index: 1;\n}\n\n.warrior-content {\n  display: flex;\n  gap: 60px;\n  position: relative;\n  z-index: 2;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.warrior-text {\n  flex: 1;\n  padding-top: 40px;\n}\n\n.warrior-text h1 {\n  font-size: 64px;\n  font-weight: bold;\n  line-height: 1.1;\n  margin: 0 0 30px 0;\n  text-transform: uppercase;\n}\n\n.warrior-text .description {\n  font-size: 18px;\n  line-height: 1.6;\n  margin-bottom: 20px;\n  max-width: 600px;\n}\n\n.warrior-text .companies {\n  font-size: 16px;\n  line-height: 1.6;\n  margin-bottom: 30px;\n  max-width: 600px;\n}\n\n.know-more-btn {\n  background-color: #A41E22;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.know-more-btn:hover {\n  background-color: #8a1a1d;\n}\n\n.warrior-images {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.main-image {\n  width: 371px;\n  height: 583px;\n  background-image: url('https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/Corporate_Thumbnail.webp');\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  margin-left: auto;\n  right: 70px;\n}\n\n/* Video styling */\nvideo.main-image {\n  background-image: none;\n  object-fit: cover;\n  width: 371px;\n  height: 583px;\n  position: relative;\n  margin-left: auto;\n  right: 70px;\n}\n\n.play-button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;\n  height: 60px;\n  background-color: rgba(164, 30, 34, 0.9);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.play-button span {\n  color: white;\n  font-size: 24px;\n  margin-left: 4px;\n}\n@media (max-width: 768px) {\n  .play-pause-button{\n    padding-top: 100px;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .warrior-container {\n    padding: 40px 20px;\n  }\n\n  .warrior-container::before {\n    left: 0;\n    right: 0;\n  }\n\n  .warrior-content {\n    flex-direction: column;\n    gap: 30px;\n  }\n\n  .warrior-text h1 {\n    font-size: 36px;\n    text-align: center;\n  }\n\n  .warrior-text .description,\n  .warrior-text .companies {\n    text-align: center;\n    font-size: 16px;\n  }\n\n  .know-more-btn {\n    display: block;\n    margin: 0 auto;\n  }\n\n  .warrior-images {\n    margin-top: 30px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n\n  .main-image {\n    position: relative;\n    right: 0;\n    margin: 0 auto;\n    width: 100%;\n    max-width: 371px;\n    height: auto;\n    aspect-ratio: 371/583;\n  }\n\n  .play-pause-button {\n    position: absolute;\n    top: 72% !important;\n    left: 50% !important;\n    transform: translate(-50%, -50%);\n    width: 50px;\n    height: 50px;\n  }\n\n  video.main-image {\n    position: relative;\n    right: 0;\n    margin: 0 auto;\n    width: 100%;\n    max-width: 371px;\n    height: auto;\n    aspect-ratio: 371/583;\n  }\n\n  .mute-button {\n    width: 35px;\n    height: 35px;\n    bottom: 15px;\n    right: 30px !important;\n  }\n}\n\n/* Just add these new rules at the end of the file */\nvideo::-webkit-media-controls {\n  display: none !important;\n}\n\nvideo::-webkit-media-controls-enclosure {\n  display: none !important;\n}\n\n.play-pause-button {\n  position: absolute;\n  top: 50%;\n  left: 78%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.7);\n  border: none;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  color: white;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.mute-button {\n  position: absolute;\n  bottom: 20px;\n  right: 80px;\n  background: rgba(0, 0, 0, 0.7);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  color: white;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.play-pause-button:hover,\n.mute-button:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n\n/* @media (min-width: 768px) and (max-width: 1024px) {\n  .warrior-container {\n    padding: 60px 40px !important;\n  }\n\n  .warrior-content {\n    gap: 30px !important;\n  }\n\n  .warrior-text h1 {\n    font-size: 48px !important;\n  }\n\n  .warrior-text .description,\n  .warrior-text .companies {\n    font-size: 16px !important;\n    max-width: 450px !important;\n  }\n  .main-image {\n    width: 300px !important;\n    height: 471px !important;\n    right: 30px !important;\n  }\n\n  video.main-image {\n    width: 300px !important;\n    height: 471px !important;\n  }\n} */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
